import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";
import RouteWrapper from "../components/RouteWrapper";
// import LocalCommunityAds from "../components/Header/LocalCummunityAds/LcaDuplicate/LocalCommunityAds";
import { FadeLoader } from "react-spinners";
import BwvCards from "../components/Header/LocalCummunityAds/BwvCards";

const CarouselComponent = lazy(
  () => import("../components/Header/LocalCummunityAds/BizzList"),
);

const CustomFields = lazy(
  () => import("../admin/CustomFieldsDashboard/CustomFields"),
);

const OrderDetails = lazy(
  () => import("../pages/DashboardPages/Orders/OrderDetails"),
);

const PaidListNew = lazy(
  () => import("../pages/DashboardPages/settingsComponents/PaidListNew"),
);
const LocalCommunityAds = lazy(
  () =>
    import("../components/Header/LocalCummunityAds/LcaDuplicate/LocalCommunityAds"),
);
const Shop = lazy(() => import("../pages/Shop"));
const Login = lazy(() => import("../pages/Login"));
const Signup = lazy(() => import("../pages/Signup"));
const ProductDetails = lazy(
  () => import("../components/Header/LocalCummunityAds/ProductDetails"),
);
const CommentsSection = lazy(
  () =>
    import("../pages/DashboardPages/MessageTemplates/MediaTemplates/adminComments"),
);
const Cart = lazy(() => import("../pages/Cart"));
const Checkout = lazy(() => import("../pages/Checkout"));
const HirePay = lazy(() => import("../components/Header/modals/HirePay"));
const UserDashboard = lazy(
  () => import("../pages/userDashboard/UserDashboard"),
);
const WishList = lazy(() => import("../pages/Wishlist"));
const AllProductList = lazy(() => import("../pages/AllproductList"));
const Dashboard = lazy(
  () => import("../components/Header/LocalCummunityAds/dashboard"),
);
const AboutUs = lazy(() => import("../pages/AboutUs"));
const TermsCondition = lazy(() => import("../pages/policy/TermsCondition"));
const Refund = lazy(() => import("../pages/policy/Refund"));
const Shipping = lazy(() => import("../pages/policy/Shipping"));
const Privacy = lazy(() => import("../pages/policy/Privacy"));
const DashboardFreeGifts = lazy(
  () => import("../pages/DashboardPages/FreeGiftPages/FreeGiftsDashboard"),
);
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Brands = lazy(() => import("../components/Brands/Brands"));
const AllCategoris = lazy(
  () => import("../components/Categories/AllCategoris"),
);
const Faq = lazy(() => import("../pages/Faq"));
const FlashDeals = lazy(
  () => import("../pages/DashboardPages/FlashDealPages/FlashDeals"),
);
const Orders = lazy(() => import("../pages/DashboardPages/Orders/Orders"));
const DashboardPage = lazy(
  () => import("../pages/DashboardPages/DashboardPage"),
);
const MyServicesPage = lazy(
  () => import("../pages/DashboardPages/ServicePages/MyServicesPage"),
);
const MyNeedsOrRequests = lazy(
  () => import("../pages/DashboardPages/NeedPages/MyNeedsOrRequests"),
);
const Settings = lazy(
  () => import("../pages/DashboardPages/settingsComponents/Settings"),
);
const SponsoredAds = lazy(
  () => import("../pages/DashboardPages/SponsordAds/SponsoredAds"),
);
const CalendarPage = lazy(() => import("../pages/DashboardPages/CalendarPage"));
const CardDetails = lazy(
  () => import("../components/Header/LocalCummunityAds/CardDetails"),
);
const Request = lazy(() => import("../pages/DashboardPages/NeedPages/Request"));
const AddNewAds = lazy(
  () => import("../pages/DashboardPages/SponsordAds/AddNewAds"),
);
const BrowseWeddingVendors = lazy(
  () => import("../components/Header/WeddingVendors/BrowseWeddingVendors"),
);
const VendorImagePopUp = lazy(
  () => import("../components/Header/WeddingVendors/VendorImagePopUp"),
);
const User = lazy(() => import("../admin/userManagement/Users"));
const Categories = lazy(() => import("../components/Categories/Categories"));
const CategoryDetails = lazy(
  () => import("../components/Categories/CategoryDetails"),
);
const Pricing = lazy(() => import("../pages/Pricing"));
const OrderSummary = lazy(
  () => import("../pages/DashboardPages/Orders/OrderSummary"),
);
const EngagedDetails = lazy(() => import("../pages/Home/EngagedDetails"));
const CreateDeal = lazy(
  () => import("../pages/DashboardPages/FlashDealPages/CreateDeal"),
);
const ThankYouPage = lazy(
  () => import("../pages/DashboardPages/Orders/ThankYouPage"),
);
const VendorDetails = lazy(
  () => import("../components/Header/WeddingVendors/VendorDetails"),
);
const ZoomEndPage = lazy(() => import("../components/ZoomMeeting/ZoomEndPage"));
const ZoomWelcomePage = lazy(
  () => import("../components/ZoomMeeting/ZoomWelcomePage"),
);
const PaymentHistoryNew = lazy(
  () => import("../pages/DashboardPages/settingsComponents/PaymentHistoryNew"),
);
const PaidList = lazy(
  () => import("../pages/DashboardPages/settingsComponents/PaidList"),
);
const UserProfile = lazy(
  () => import("../components/Header/UserDetails/UserProfile"),
);
const CommunityPosts = lazy(
  () =>
    import("../components/Header/LocalCummunityAds/CommunityDisscussions/CommunityPosts"),
);
const Questions = lazy(() => import("../admin/NeedQnsDashboard/NeedQuestions"));
const ReviewService = lazy(() => import("../components/Header/ReviewService"));
const MyFavourites = lazy(() => import("../pages/DashboardPages/MyFavourites"));
const CreateService = lazy(
  () => import("../pages/DashboardPages/ServicePages/CreateService"),
);
const ReportAllLogs = lazy(
  () => import("../pages/DashboardPages/Reports/UserEngagements/ReportAllLogs"),
);
const NotifyList = lazy(() => import("../pages/DashboardPages/NotifyList"));
const ResetPwPage = lazy(() => import("../pages/ResetPwPage"));
const RequestNeedVersion2 = lazy(
  () => import("../pages/DashboardPages/NeedPages/RequestNeedVersion2"),
);
const InboxPage2 = lazy(
  () => import("../pages/DashboardPages/inboxPages/InboxPage2"),
);
const MyItemsForSale = lazy(
  () => import("../pages/DashboardPages/ItemsForSale/MyItemsForSale"),
);
const CreateItem = lazy(
  () => import("../pages/DashboardPages/ItemsForSale/CreateItem"),
);
const PeopleInMyCom = lazy(
  () => import("../pages/PeopleInMyCommunity/PeopleInMyCom"),
);
const PeopleProfile = lazy(
  () => import("../pages/PeopleInMyCommunity/PeopleProfile"),
);
const ItemsForSale = lazy(
  () => import("../components/Header/Items/ItemsForSale"),
);
const MyGurudwaraPage = lazy(
  () => import("../pages/DashboardPages/GurdwaraPages/MyGurudwaraPage"),
);
const LogNotes = lazy(() => import("../components/EmbeddedUI/LogNotes"));
const ListNotes = lazy(() => import("../components/EmbeddedUI/ListNotes"));
const CreateGurdwara = lazy(
  () => import("../pages/DashboardPages/GurdwaraPages/CreateGurdwara"),
);
const BookGurdwara = lazy(
  () =>
    import("../pages/DashboardPages/GurdwaraPages/BookGurdwara/BookGurdwara"),
);
const ItemReview = lazy(() => import("../components/Header/Items/ItemReview"));
const NotifyCustomer = lazy(
  () => import("../pages/DashboardPages/ItemsForSale/NotifyCustomer"),
);
const ConnectionNotify = lazy(
  () => import("../pages/DashboardPages/inboxPages/ConnectionNotify"),
);
const JobNotify = lazy(
  () => import("../pages/DashboardPages/inboxPages/JobNotify"),
);
const MyTemplates = lazy(
  () => import("../pages/DashboardPages/MessageTemplates/MyTemplates"),
);
const ItemDetails = lazy(
  () => import("../components/Header/Items/itemsDetails"),
);
const Home = lazy(() => import("../pages/Home/Home"));
const MyTemplatesDashboard = lazy(
  () =>
    import("../pages/DashboardPages/MessageTemplates/MediaTemplates/MyTemplatesDashboard"),
);
const ReportLogs = lazy(
  () =>
    import("../pages/DashboardPages/MessageTemplates/MediaTemplates/ReportLogs"),
);
const ReviewMessages = lazy(
  () => import("../pages/DashboardPages/inboxPages/ReviewMessages"),
);
const DealFactors = lazy(
  () =>
    import("../pages/DashboardPages/ServicePages/ServicePackages/DealFactors"),
);
const MyCommunityWebSites = lazy(
  () => import("../pages/DashboardPages/CommunityWebSites/MyCommunityWebSites"),
);
const MyCommunityDiscussions = lazy(
  () =>
    import("../pages/DashboardPages/CommunityDiscussions/MyCommunityDiscussions"),
);
const InvoicePayment = lazy(
  () =>
    import("../pages/DashboardPages/inboxPages/AllDropDowns/InvoicePayment"),
);
const MyGurudwaraNewsPage = lazy(
  () => import("../pages/DashboardPages/GurdwaraPages/MyGurudwaraNewsPage"),
);
const CreateGurdwaraNews = lazy(
  () => import("../pages/DashboardPages/GurdwaraPages/CreateGurdwaraNews"),
);
const CreateWebSite = lazy(
  () => import("../pages/DashboardPages/CommunityWebSites/CreateWebSite"),
);
const GurdwaraNewsDetail = lazy(
  () => import("../pages/DashboardPages/GurdwaraPages/GurdwaraNewsDetail"),
);
const CreatePost = lazy(
  () => import("../pages/DashboardPages/CommunityDiscussions/CreatePost"),
);
const PostDetails = lazy(
  () =>
    import("../components/Header/LocalCummunityAds/CommunityDisscussions/PostDetails"),
);
const ReportManagement = lazy(
  () => import("../pages/DashboardPages/Reports/ReportManagement"),
);
const ReportsDashboard = lazy(
  () => import("../pages/DashboardPages/Reports/ReportDashboard"),
);
const DashboardReports = lazy(
  () => import("../pages/DashboardPages/AllReports/DashboardReports"),
);
const AllGottonReports = lazy(
  () => import("../pages/DashboardPages/AllReports/AllGottonCustomers"),
);
const OneDayReport = lazy(
  () => import("../pages/DashboardPages/AllReports/GottonOneDay"),
);
const EventsWith150Guest = lazy(
  () => import("../pages/DashboardPages/AllReports/EventsWith150Guest"),
);
const CustomersGottenReport = lazy(
  () =>
    import("../pages/DashboardPages/Reports/GottonReports/CustomersGottenReport"),
);
const Customers150 = lazy(
  () => import("../pages/DashboardPages/Reports/Events150.jsx/Customers150"),
);
const UsersClicksReport = lazy(
  () =>
    import("../pages/DashboardPages/Reports/UserEngagements/UserClicksReport"),
);
const AutoScheduleMessages = lazy(
  () =>
    import("../pages/DashboardPages/AutoScheduleMessages/AutoScheduleMessages"),
);
const CustomerInitiated = lazy(
  () => import("../admin/CustomerInitiated/CustomerInitiated"),
);
const Customer24hreport = lazy(
  () => import("../pages/DashboardPages/Reports/GottonReports/Gotton24Report"),
);
const EnlargeImageView = lazy(
  () => import("../components/ExplorerModule/enlargeimage"),
);
const HeroGridLayout = lazy(
  () => import("../components/ExplorerModule/gridView"),
);

const Routers = ({ open, setOpen }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin";
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );

  return (
    <Suspense
      fallback={
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            position: "relative",
            height: "100vh",
          }}
        >
          <FadeLoader
            color={"#36D7B7"}
            loading={true}
            className="position-absolute top-50 start-50 translate-middle"
          />
        </div>
      }
    >
      <Routes>
        {/* Public Routes (Accessible without login) */}
        {/* {!islogin && ( */}
        <>
          <Route
            path="login"
            element={
              <RouteWrapper>
                <Login open={open} setOpen={setOpen} />
              </RouteWrapper>
            }
          />
          <Route
            path="signup"
            element={
              <RouteWrapper>
                <Signup />
              </RouteWrapper>
            }
          />
          <Route
            path="/*"
            element={
              <RouteWrapper>
                <LocalCommunityAds />
              </RouteWrapper>
            }
          />
          <Route
            path="majesticHomePage"
            element={
              <RouteWrapper>
                <Home />
              </RouteWrapper>
            }
          />
          <Route
            path="order-list"
            element={
              <RouteWrapper>
                <Cart />
              </RouteWrapper>
            }
          />
          <Route
            path="settings/reset-password/:Id"
            element={
              <RouteWrapper>
                <ResetPwPage />
              </RouteWrapper>
            }
          />
          <Route
            path="home"
            element={
              <RouteWrapper>
                <LocalCommunityAds />
              </RouteWrapper>
            }
          />
          <Route
            path="Localcommunityads"
            element={
              <RouteWrapper>
                <LocalCommunityAds />
              </RouteWrapper>
            }
          />
          <Route
            path="/weddingvendors"
            element={
              <RouteWrapper>
                <BrowseWeddingVendors />
              </RouteWrapper>
            }
          />
          <Route
            path="faq/"
            element={
              <RouteWrapper>
                <Faq />
              </RouteWrapper>
            }
          />
          <Route
            path="/privacypolicies"
            element={
              <RouteWrapper>
                <Privacy />
              </RouteWrapper>
            }
          />
          <Route
            path="about/shipping/:shipping"
            element={
              <RouteWrapper>
                <Shipping />
              </RouteWrapper>
            }
          />
          <Route
            path="about/refund/:refund"
            element={
              <RouteWrapper>
                <Refund />
              </RouteWrapper>
            }
          />
          <Route
            path="about/terms/condition/:termsCondition"
            element={
              <RouteWrapper>
                <TermsCondition />
              </RouteWrapper>
            }
          />
          <Route
            path="contact/us/:contactUs"
            element={
              <RouteWrapper>
                <ContactUs />
              </RouteWrapper>
            }
          />
          <Route
            path="shop/:id"
            element={
              <RouteWrapper>
                <ProductDetails />
              </RouteWrapper>
            }
          />
          <Route
            path="all-products"
            element={
              <RouteWrapper>
                <Dashboard />
              </RouteWrapper>
            }
          />
          <Route
            path="pricing"
            element={
              <RouteWrapper>
                <Pricing />
              </RouteWrapper>
            }
          />
          <Route
            path="/requestDetails/:Id"
            element={
              <RouteWrapper>
                <CardDetails />
              </RouteWrapper>
            }
          />
          <Route
            path="/vendordetails/:Id"
            element={
              <RouteWrapper>
                <VendorDetails />
              </RouteWrapper>
            }
          />
          <Route
            path="/engagedCouple/:Id"
            element={
              <RouteWrapper>
                <EngagedDetails />
              </RouteWrapper>
            }
          />
          <Route
            path="/needs-requests/request"
            element={
              <RouteWrapper>
                <Request />
              </RouteWrapper>
            }
          />
          <Route
            path="/create-need/request"
            element={
              <RouteWrapper>
                <RequestNeedVersion2 />
              </RouteWrapper>
            }
          />
          <Route
            path="/zoom-meeting"
            element={
              <RouteWrapper>
                <ZoomWelcomePage />
              </RouteWrapper>
            }
          />
          <Route
            path="/thankyou"
            element={
              <RouteWrapper>
                <ZoomEndPage />
              </RouteWrapper>
            }
          />
          <Route
            path="/feedBack/:id"
            element={
              <RouteWrapper>
                <ReviewService />
              </RouteWrapper>
            }
          />
          <Route
            path="/item-review"
            element={
              <RouteWrapper>
                <ItemReview />
              </RouteWrapper>
            }
          />
          <Route
            path="/notify-pickup/:id"
            element={
              <RouteWrapper>
                <NotifyCustomer />
              </RouteWrapper>
            }
          />
          <Route
            path="/bookGurdwara/:selectedGurdwara/:step"
            element={
              <RouteWrapper>
                <BookGurdwara />
              </RouteWrapper>
            }
          />
          <Route
            path="invoicePayment/:Id"
            element={
              <RouteWrapper>
                <InvoicePayment />
              </RouteWrapper>
            }
          />
          <Route
            path="/userDetails/:id"
            element={
              <RouteWrapper>
                <UserProfile />
              </RouteWrapper>
            }
          />
          <Route
            path="/CommunityPosts"
            element={
              <RouteWrapper>
                <CommunityPosts />
              </RouteWrapper>
            }
          />
          <Route
            path="/all-products/:gurdwara"
            element={
              <RouteWrapper>
                <Dashboard />
              </RouteWrapper>
            }
          />
            <Route
                  path="/order-summary"
                  element={
                    <RouteWrapper>
                      <OrderSummary />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/order-summary/:orderId"
                  element={
                    <RouteWrapper>
                      <OrderSummary />
                    </RouteWrapper>
                  }
                />
        </>
        {/* )} */}

        {/* Authenticated Routes */}
        {islogin && (
          <>
            <Route
              path="/dashboardpage/settings"
              element={
                <RouteWrapper>
                  <Settings />
                </RouteWrapper>
              }
            />
            <Route
              path="/test"
              element={
                <RouteWrapper>
                  <CarouselComponent />
                </RouteWrapper>
              }
            />

            <Route
              path="/dashboardpage/settings/:tab"
              element={
                <RouteWrapper>
                  <Settings />
                </RouteWrapper>
              }
            />
            <Route
              path="/vendordetails/:Id"
              element={
                <RouteWrapper>
                  <VendorDetails />
                </RouteWrapper>
              }
            />
            <Route
              path="/heroGridLayout"
              element={
                <RouteWrapper>
                  <HeroGridLayout />
                </RouteWrapper>
              }
            />
            <Route
              path="/vendordetails/:Id/:tab"
              element={
                <RouteWrapper>
                  <VendorDetails />
                </RouteWrapper>
              }
            />

            {!isProfileComplete && (
              <>
                <Route
                  path="*"
                  element={<Navigate to="/dashboardpage/settings" replace />}
                />
                <Route
                  path="/vendordetails/:Id"
                  element={
                    <RouteWrapper>
                      <VendorDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/vendordetails/:Id/:tab"
                  element={
                    <RouteWrapper>
                      <VendorDetails />
                    </RouteWrapper>
                  }
                />
              </>
            )}

            {isProfileComplete && (
              <>
                <Route
                  path="/dashboardpage"
                  element={
                    <RouteWrapper>
                      <DashboardPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/my-services"
                  element={
                    <RouteWrapper>
                      <MyServicesPage />
                    </RouteWrapper>
                  }
                />
                {/* Admin Routes */}
                {isAdmin && (
                  <>
                    <Route
                      path="/dashboardpage/reports/customers-gotten"
                      element={
                        <RouteWrapper>
                          <CustomersGottenReport />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/comments-section"
                      element={
                        <RouteWrapper>
                          <CommentsSection />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reportlogs"
                      element={
                        <RouteWrapper>
                          <ReportLogs />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reports/customers-gotten-24-hours"
                      element={
                        <RouteWrapper>
                          <Customer24hreport />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reports/events-with-150-attendees"
                      element={
                        <RouteWrapper>
                          <Customers150 />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reports/user-engagement"
                      element={
                        <RouteWrapper>
                          <UsersClicksReport />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reports"
                      element={
                        <RouteWrapper>
                          <ReportsDashboard />
                        </RouteWrapper>
                      }
                    />
                    {/* All new Reports routes */}
                    <Route
                      path="/dashboardpage/all-reports"
                      element={
                        <RouteWrapper>
                          <DashboardReports />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/all-reports/gotton-customers"
                      element={
                        <RouteWrapper>
                          <AllGottonReports />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/all-reports/gotten-customers-24-hours"
                      element={
                        <RouteWrapper>
                          <OneDayReport />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/all-reports/events-with-150-guests"
                      element={
                        <RouteWrapper>
                          <EventsWith150Guest />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/admin/categorymanagement"
                      element={
                        <RouteWrapper>
                          <Categories />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/admin/questions"
                      element={
                        <RouteWrapper>
                          <Questions />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/admin/vendor-questions"
                      element={
                        <RouteWrapper>
                          <CustomFields />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/notifications/Review"
                      element={
                        <RouteWrapper>
                          <ReviewMessages />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reportManagement"
                      element={
                        <RouteWrapper>
                          <ReportManagement />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/dashboardpage/reportalllogs"
                      element={
                        <RouteWrapper>
                          <ReportAllLogs />
                        </RouteWrapper>
                      }
                    />
                    <Route
                      path="/admin/usermanagement"
                      element={
                        <RouteWrapper>
                          <User />
                        </RouteWrapper>
                      }
                    />
                  </>
                )}
                <Route
                  path="/order-details/:id"
                  element={
                    <RouteWrapper>
                      <OrderDetails />
                    </RouteWrapper>
                  }
                />
                {/* Dashboard Routes */}
                <Route
                  path="/dashboardpage/free-gifts"
                  element={
                    <RouteWrapper>
                      <DashboardFreeGifts />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/calendar"
                  element={
                    <RouteWrapper>
                      <CalendarPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/myFavorites"
                  element={
                    <RouteWrapper>
                      <MyFavourites />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/create-website"
                  element={
                    <RouteWrapper>
                      <CreateWebSite />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/create-post/:tab"
                  element={
                    <RouteWrapper>
                      <CreatePost />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/notifyList"
                  element={
                    <RouteWrapper>
                      <NotifyList />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/needs-requests"
                  element={
                    <RouteWrapper>
                      <MyNeedsOrRequests />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/flash-Deals"
                  element={
                    <RouteWrapper>
                      <FlashDeals />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/flash-deals/new-deal"
                  element={
                    <RouteWrapper>
                      <CreateDeal />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/sponsored-ads"
                  element={
                    <RouteWrapper>
                      <SponsoredAds />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/inbox"
                  element={
                    <RouteWrapper>
                      <InboxPage2 />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/inbox/:tab"
                  element={
                    <RouteWrapper>
                      <InboxPage2 />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/inbox/chat-id/:chatId"
                  element={
                    <RouteWrapper>
                      <InboxPage2 />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/message-templates"
                  element={
                    <RouteWrapper>
                      <MyTemplates />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/community-websites"
                  element={
                    <RouteWrapper>
                      <MyCommunityWebSites />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/community-discussions/:tab"
                  element={
                    <RouteWrapper>
                      <MyCommunityDiscussions />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/media-templates"
                  element={
                    <RouteWrapper>
                      <MyTemplatesDashboard />
                    </RouteWrapper>
                  }
                />

                <Route
                  path="/dashboardpage/orders"
                  element={
                    <RouteWrapper>
                      <Orders />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/lognotes"
                  element={
                    <RouteWrapper>
                      <LogNotes />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/listnotes"
                  element={
                    <RouteWrapper>
                      <ListNotes />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/gurdwaramanagement"
                  element={
                    <RouteWrapper>
                      <MyGurudwaraPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/gurdwaraNews"
                  element={
                    <RouteWrapper>
                      <MyGurudwaraNewsPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/gurdwaraNewsDetails/:Id"
                  element={
                    <RouteWrapper>
                      <GurdwaraNewsDetail />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/createGurdwaraNews"
                  element={
                    <RouteWrapper>
                      <CreateGurdwaraNews />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/manageGurdwara"
                  element={
                    <RouteWrapper>
                      <CreateGurdwara />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/my-items"
                  element={
                    <RouteWrapper>
                      <MyItemsForSale />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/autoScheduleMessages"
                  element={
                    <RouteWrapper>
                      <AutoScheduleMessages />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/dashboardpage/customerinitiated"
                  element={
                    <RouteWrapper>
                      <CustomerInitiated />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="items-for-sale"
                  element={
                    <RouteWrapper>
                      <ItemsForSale />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/create-item"
                  element={
                    <RouteWrapper>
                      <CreateItem />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/create-service"
                  element={
                    <RouteWrapper>
                      <CreateService />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/create-service/:id"
                  element={
                    <RouteWrapper>
                      <CreateService />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/all/product"
                  element={
                    <RouteWrapper>
                      <AllProductList />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/ad/sponsored/new"
                  element={
                    <RouteWrapper>
                      <AddNewAds />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="dealFactors"
                  element={
                    <RouteWrapper>
                      <DealFactors />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="product/list/:category_id/:subcategory_id/:type/:offer_id"
                  element={
                    <RouteWrapper>
                      <Shop />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="products/list/:category_id/:subcategory_id/:type/:offer/:brand_id"
                  element={
                    <RouteWrapper>
                      <AllProductList />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="product/wishlist"
                  element={
                    <RouteWrapper>
                      <WishList />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="shop/:id"
                  element={
                    <RouteWrapper>
                      <ProductDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="cart"
                  element={
                    <RouteWrapper>
                      <Cart />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="checkout"
                  element={
                    <RouteWrapper>
                      <Checkout />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="user/deshboard/:activ"
                  element={
                    <RouteWrapper>
                      <UserDashboard />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="about/privacy/:privacy"
                  element={
                    <RouteWrapper>
                      <Privacy />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="about/shipping/:shipping"
                  element={
                    <RouteWrapper>
                      <Shipping />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="about/refund/:refund"
                  element={
                    <RouteWrapper>
                      <Refund />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="about/terms/condition/:termsCondition"
                  element={
                    <RouteWrapper>
                      <TermsCondition />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="contact/us/:contactUs"
                  element={
                    <RouteWrapper>
                      <ContactUs />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="all/brands"
                  element={
                    <RouteWrapper>
                      <Brands />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="all/category"
                  element={
                    <RouteWrapper>
                      <AllCategoris />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="faq/"
                  element={
                    <RouteWrapper>
                      <Faq />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/order/payment"
                  element={
                    <RouteWrapper>
                      <HirePay />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/category/:id"
                  element={
                    <RouteWrapper>
                      <CategoryDetails />
                    </RouteWrapper>
                  }
                />
              
                <Route
                  path="/Order/placed"
                  element={
                    <RouteWrapper>
                      <ThankYouPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/cashout/history"
                  element={
                    <RouteWrapper>
                      <PaymentHistoryNew />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/cashout/PaidList"
                  element={
                    <RouteWrapper>
                      {/* <PaidList /> */}
                      <PaidListNew />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/notifications/Connection-requests"
                  element={
                    <RouteWrapper>
                      <ConnectionNotify />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/notifications/job-offers"
                  element={
                    <RouteWrapper>
                      <JobNotify />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/people-in-mycommunity"
                  element={
                    <RouteWrapper>
                      <PeopleInMyCom />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/people-profile/:Id"
                  element={
                    <RouteWrapper>
                      <PeopleProfile />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/item-details/:Id"
                  element={
                    <RouteWrapper>
                      <ItemDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/postDetails/:Id"
                  element={
                    <RouteWrapper>
                      <PostDetails />
                    </RouteWrapper>
                  }
                />

                {/* Default routes for authenticated users */}
                <Route
                  path="/*"
                  element={
                    <RouteWrapper>
                      <LocalCommunityAds />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="majesticHomePage"
                  element={
                    <RouteWrapper>
                      <Home />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="order-list"
                  element={
                    <RouteWrapper>
                      <Cart />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="settings/reset-password/:Id"
                  element={
                    <RouteWrapper>
                      <ResetPwPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="home"
                  element={
                    <RouteWrapper>
                      <LocalCommunityAds />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="Localcommunityads"
                  element={
                    <RouteWrapper>
                      <LocalCommunityAds />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/weddingvendors"
                  element={
                    <RouteWrapper>
                      <BrowseWeddingVendors />
                    </RouteWrapper>
                  }
                />

                <Route
                  path="/vendorimagepopup"
                  element={
                    <RouteWrapper>
                      <VendorImagePopUp />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/requestDetails/:Id"
                  element={
                    <RouteWrapper>
                      <CardDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/vendordetails/:Id"
                  element={
                    <RouteWrapper>
                      <VendorDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/vendordetails/:Id/:tab"
                  element={
                    <RouteWrapper>
                      <VendorDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/engagedCouple/:Id"
                  element={
                    <RouteWrapper>
                      <EngagedDetails />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/needs-requests/request"
                  element={
                    <RouteWrapper>
                      <Request />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/create-need/request"
                  element={
                    <RouteWrapper>
                      <RequestNeedVersion2 />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/zoom-meeting"
                  element={
                    <RouteWrapper>
                      <ZoomWelcomePage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/thankyou"
                  element={
                    <RouteWrapper>
                      <ZoomEndPage />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/feedBack/:id"
                  element={
                    <RouteWrapper>
                      <ReviewService />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/item-review"
                  element={
                    <RouteWrapper>
                      <ItemReview />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/notify-pickup/:id"
                  element={
                    <RouteWrapper>
                      <NotifyCustomer />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/bookGurdwara/:selectedGurdwara/:step"
                  element={
                    <RouteWrapper>
                      <BookGurdwara />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="invoicePayment/:id"
                  element={
                    <RouteWrapper>
                      <InvoicePayment />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/userDetails/:id"
                  element={
                    <RouteWrapper>
                      <UserProfile />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/CommunityPosts"
                  element={
                    <RouteWrapper>
                      <CommunityPosts />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="/all-products/:gurdwara"
                  element={
                    <RouteWrapper>
                      <Dashboard />
                    </RouteWrapper>
                  }
                />
                <Route
                  path="all-products"
                  element={
                    <RouteWrapper>
                      <Dashboard />
                    </RouteWrapper>
                  }
                />
              </>
            )}
          </>
        )}

        {/* Special Routes (No Authentication Check) */}
        {/* <Route
          path="/enlargeImageView/:createdBy"
          element={
            <RouteWrapper>
              <EnlargeImageView />
            </RouteWrapper>
          }
        /> */}
        <Route
          path="/enlargeImageView"
          element={
            <RouteWrapper>
              <EnlargeImageView />
            </RouteWrapper>
          }
        />

        <Route
          path="/privacypolicies"
          element={
            <RouteWrapper>
              <Privacy />
            </RouteWrapper>
          }
        />
        <Route
          path="aboutus/"
          element={
            <RouteWrapper>
              <AboutUs />
            </RouteWrapper>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default Routers;
